'use strict';

function createPublicationRunId(now = Date.now(), random = Math.random()) {
  return `publication-run-${Number(now).toString(36)}-${Math.floor(Number(random) * 0x1000000).toString(36)}`;
}

function getEntryDate(entry) {
  return entry?.date || entry?.addedAt || entry?.lastUpdated || '';
}

function toCount(value) {
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : 0;
}

function splitErrorSummary(errorSummary) {
  const raw = String(errorSummary || '');
  const separatorIndex = raw.indexOf(': ');
  if (separatorIndex === -1) {
    return { product: 'Producto no especificado', error: raw || 'Error no especificado' };
  }
  return {
    product: raw.slice(0, separatorIndex).trim() || 'Producto no especificado',
    error: raw.slice(separatorIndex + 2).trim() || raw
  };
}

function getPublicationRunSummary(entries) {
  const runEntries = Array.isArray(entries) ? entries : [];
  const errors = runEntries.flatMap(entry => (
    (Array.isArray(entry?.errorSummary) ? entry.errorSummary : []).map(errorSummary => {
      const parsedError = splitErrorSummary(errorSummary);
      const product = (Array.isArray(entry?.products) ? entry.products : []).find(item => (
        item?.status === 'failed' && item?.title === parsedError.product
      ));
      return {
        ...parsedError,
        fileName: entry?.fileName || 'Archivo no especificado',
        itemId: product?.mlId || product?.sku || product?.id || null
      };
    })
  ));

  return {
    totalProducts: runEntries.reduce((total, entry) => total + toCount(entry?.totalProducts ?? entry?.details?.total), 0),
    successCount: runEntries.reduce((total, entry) => total + toCount(entry?.successCount ?? entry?.details?.successful), 0),
    failedCount: runEntries.reduce((total, entry) => total + toCount(entry?.failedCount ?? entry?.details?.failed), 0),
    errors
  };
}

function groupPublicationHistory(entries) {
  const groupsByKey = new Map();
  (Array.isArray(entries) ? entries : []).forEach((entry, index) => {
    const publicationRunId = entry?.publicationRunId || null;
    const groupKey = publicationRunId ? `run:${publicationRunId}` : `legacy:${entry?.id ?? index}`;
    if (!groupsByKey.has(groupKey)) {
      groupsByKey.set(groupKey, { publicationRunId, entries: [] });
    }
    groupsByKey.get(groupKey).entries.push(entry);
  });

  return Array.from(groupsByKey.values()).map(group => ({
    ...group,
    startedAt: getEntryDate(group.entries[group.entries.length - 1]) || getEntryDate(group.entries[0]),
    isComplete: group.entries.every(entry => entry?.status !== 'in-progress'),
    summary: getPublicationRunSummary(group.entries)
  }));
}

module.exports = {
  createPublicationRunId,
  getPublicationRunSummary,
  groupPublicationHistory,
  splitErrorSummary
};